<template>
  <v-btn
    :color="recording ?'error' :'success'"
    depressed
    @click="$emit('click')"
    :fab="$vuetify.breakpoint.xs || small"
    :small="$vuetify.breakpoint.xs || small"
    :width="$vuetify.breakpoint.smAndUp && !small ?180 :'inherit'"
    outlined
  >
    <v-fade-transition>
      <v-icon v-if="recording">$vuetify.icons.appMicrophoneOn</v-icon>
      <v-icon v-else>$vuetify.icons.appMicrophone</v-icon>
    </v-fade-transition>
    <span
      class="ml-2"
      v-if="$vuetify.breakpoint.smAndUp && !small"
    >{{recording ?'Stop Record' :'Record Audio'}}</span>
  </v-btn>
</template>
<script>
export default {
  props: {
    recording: Boolean,
    small: Boolean,
  },
};
</script>